import { Controller } from "@hotwired/stimulus"
import { useTransition } from "stimulus-use"

export default class extends Controller {
  static targets = ["menu", "icon", "altIcon", "title", "button"]
  static values = {
    open: String,
    close: String,
    hideTrigger: { type: Boolean, default: false },
    settingKey: String,
  }

  connect() {
    if (this.hasMenuTarget) {
      // Wyczytaj stan początkowy z DOM — inaczej useTransition domyślnie ustawi transitioned=false
      // i dołoży "hidden" nawet gdy ERB wyrenderował menu jako otwarte.
      const initialOpen = !this.menuTarget.classList.contains("hidden")
      useTransition(this, { element: this.menuTarget, transitioned: initialOpen })
    }
  }

  toggle() {
    this.toggleTransition()

    if (this.hasAltIconTarget) {
      this.iconTarget.classList.toggle("hidden")
      this.altIconTarget.classList.toggle("hidden")
    } else if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("-rotate-180")
    }

    if (this.hasTitleTarget) {
      this.titleTarget.innerHTML = this.iconTarget.classList.contains("-rotate-180") ? this.closeValue : this.openValue
    }

    if (this.hideTriggerValue) {
      this.buttonTarget.classList.toggle("hidden")
    }

    // zapamiętaj stan rozwijaka w ustawieniach usera (settings_value).
    // Używamy this.transitioned (ustawione sync przez useTransition) zamiast classList.contains("hidden"),
    // bo leave() dodaje "hidden" dopiero po await — sprawdzanie DOM zwracałoby zły stan przy zamykaniu.
    if (this.hasSettingKeyValue && this.settingKeyValue) {
      IntumJs.setField(this.settingKeyValue, !!this.transitioned, { check: false })
    }
  }

  open() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.toggle()
    }
  }
}
